// extracted by mini-css-extract-plugin
export default {"heading":"Px-z","corrected":"Qx-z","redirectVerbiageContainer":"Rx-z","redirectVerbiageText":"Sx-z"};